export var DEPLOY_DATE = new Date('2026-01-13T08:36:58+0000');
